<div class="img-wrapper">
    <div class="img-block">
        <div class="lable-wrapper">
            <span class="lable1" *ngIf="product.new">new</span>
            <span class="lable2" *ngIf="product.sale">{{ product?.discount }}% off</span>
        </div>
        <div class="front">
            <a [routerLink]="['/shop/product/left/sidebar', product.title.replace(' ', '-'), product.sku]">
                <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'" 
                     [lazyLoad]="ImageSrc ? ImageSrc : product.images[0]"  
                     class="img-fluid lazy-loading" alt="{{ product.images[0] }}">
            </a>
        </div>
        <div class="back" *ngIf="onHowerChangeImage">
            <a [routerLink]="['/shop/product/left/sidebar/', product.title.replace(' ', '-')]">
                <img [src]="ImageSrc ? ImageSrc : product.images[1]" class="img-fluid lazy-loading" alt="{{ product.images[1] }}">
            </a>
        </div>
        <div class="cart-info" *ngIf="product.activaStock === true">
            <!-- <button title="Agregar al carrito" (click)="CartModal.openModal(product)" 
                *ngIf="cartModal && product.activaStock === true">
                <i class="ti-shopping-cart"></i>
            </button>
            <button title="Agregar al carrito" (click)="addToCart(product)"
                *ngIf="!cartModal && product.activaStock === true && product.stock > 0">
                <i class="ti-shopping-cart"></i>
            </button> -->
            <a href="javascript:void(0)" title="Agregar a Lista de Deseos" (click)="addToWishlist(product)">
              <i class="ti-heart" aria-hidden="true"></i>
            </a>
            <a href="javascript:void(0)" title="Vista Rápida" (click)="QuickView.openModal()">
              <i class="ti-search" aria-hidden="true"></i>
            </a>
            <a href="javascript:void(0)" title="Comparar" (click)="addToCompare(product)">
              <i class="ti-reload" aria-hidden="true"></i>
            </a>
        </div>
    </div>
  </div>
  <div class="product-detail">
    <div>
      <!-- <bar-rating [rate]="5" [readOnly]="true"></bar-rating> -->
      <a [routerLink]="['/shop/product/left/sidebar/', product?.title.replace(' ', '-')]">
        <h6>{{ product?.title | titlecase }}</h6>
      </a>
      <h4>
        {{ product.priceDiscount | currency:currency?.currency:'symbol' }}
        <del *ngIf="product?.tienePromocion"><span class="money"> {{ product?.price * currency?.price | currency:currency?.currency:'symbol' }}</span></del>
      </h4>
      <div class="delivery-txt pt-2" *ngIf="product.envioGratis===true">Envío Gratis</div>
      <ul class="color-variant" *ngIf="Color(product?.variants).length">
        <li [class]="color" *ngFor="let color of Color(product?.variants)" [ngStyle]="{'background-color': color}"
          (click)="ChangeVariants(color, product)">
        </li>
      </ul>
    </div>
  </div>
  
  <app-quick-view #quickView [product]="product" [currency]="currency"></app-quick-view>
  <app-cart-modal #cartModal [product]="product" [currency]="currency" *ngIf="cartModal"></app-cart-modal>
  
  